
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { TrafficLightComponent } from './traffic-light.component';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'traffic-light-dropdown',
    template: `
<div class="selection-holder" [ngClass]="{readOnly:readOnly}" [matMenuTriggerFor]="selectionsMenu" (click)="$event.stopPropagation()">
  <traffic-light 
    [color]="colorObject[selected]" 
    [text]="(textObject ? textObject[selected] : null) || selected">
  </traffic-light>
  <div class="arrow_drop_down_holding_space"  *ngIf="!readOnly">
    <mat-icon>arrow_drop_down</mat-icon>
  </div>
  <mat-menu #selectionsMenu="matMenu" xPosition="before">
    <ng-container *ngIf="!readOnly">
      <button mat-menu-item *ngFor="let selection of selections" (click)="select.emit(selection)">
        <traffic-light [color]="colorObject[selection]" [text]="(textObject ? textObject[selection] : null) || selection" ></traffic-light>
      </button>
    </ng-container>
  </mat-menu>
</div>
`,
    styles: [`
  .arrow_drop_down_holding_space { width:24px; margin-bottom: -5px; }
  .selection-holder { display: flex; flex-direction: row; align-items: center; cursor: pointer; }
  .selection-holder.readOnly { cursor: default; pointer-events: none; }
  .selection-holder mat-icon { color: var(--normal-text); }
  ::ng-deep .selection-holder mat-menu .light-holder { padding: 0 10px 0 0; height: 38px; }
  ::ng-deep .selection-holder.readOnly .light-holder { cursor: default; }
`],
    standalone: true,
    imports: [TrafficLightComponent, MatMenuModule, CommonModule, MatIconModule]
})
export class TrafficLightDropdownComponent {
  @Input() colorObject: { [sId: string]: string } = {}
  @Input() textObject: { [sId: string]: string } = {}
  @Input() selected: string
  @Input() selections: string[]
  @Input() readOnly = false
  @Output() select: EventEmitter<string> = new EventEmitter()
}

